var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfulTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 75C16.7893 75 0 58.2107 0 37.5C0 16.7893 16.7893 0 37.5 0C58.2107 0 75 16.7893 75 37.5C75 58.2107 58.2107 75 37.5 75ZM46.8249 26.6547C48.1201 24.9012 50.5917 24.5296 52.3453 25.8249C54.0988 27.1201 54.4704 29.5917 53.1751 31.3453L42.6395 45.6088C38.2296 51.5792 29.2541 51.4361 25.0368 45.3281L23.2517 42.7428C22.013 40.9489 22.4632 38.4904 24.2572 37.2517C26.0511 36.013 28.5096 36.4632 29.7483 38.2572L31.5334 40.8425C32.6728 42.4927 35.0978 42.5314 36.2893 40.9183L46.8249 26.6547Z",
    fill: "#478620"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulTransaction);
export default __webpack_public_path__ + "static/media/successfulTransaction.14a2ae9e500dd2f07822575e83e5d364.svg";
export { ForwardRef as ReactComponent };